import styled from "styled-components";
import { MainWrapper } from "@/lib/styles";

export const BackgroundContainer = styled.div`
  position: relative;
  padding-top: 0;
  background-color: ${({ theme }) => theme.colors.lightGrey};

  opacity: 0;
  transform: translateY(100px);
`;

export const Container = styled(MainWrapper)`
  ${({ theme }) => theme.mediaQueries.tablet} {
    display: flex;
  }
`

export const Heading = styled.div`
  height: max-content;
  position: sticky;
  align-items: flex-start;
  padding-top: 3.75rem;
  margin-bottom: 3.75rem;

  background-color: ${({ theme }) => theme.colors.lightGrey};
  top: ${({ theme }) => theme.space.headerMinHeight};

  ${({ theme }) => theme.mediaQueries.tablet} {
    flex: 1;
    margin-bottom: 0;
    padding: 2.5rem 0;
    background-color: transparent;
  }
`;

export const Content = styled.div`
  ${({ theme }) => theme.mediaQueries.tablet} {
    flex: 1;
    padding: 2.5rem 0;
  }
`;

export const Title = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 400;
  line-height: 1.6;
  font-size: 0.875rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

export const Counter = styled.div`
  display: none;
  ${({ theme }) => theme.mediaQueries.tablet} {
    display: flex;
    gap: 1.25rem;
    font-family: ${({ theme }) => theme.fontFamilies.primary};
    font-style: normal;
    font-weight: 400;
    font-size: 7.5rem;
    line-height: 0.9;
    user-select: none;

    color: ${({ theme }) => theme.colors.red};
    span:last-child {
      color: ${({ theme }) => theme.colors.black};
      opacity: 20%;
    }
  }
`;
